import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { defaultUserImg, dummyAudio } from "../../Constants/Images";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeartBroken,
  faMicrophone,
  faSmile,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFaceSmile,
  faHeart,
  faPaperPlane,
  faThumbsUp,
} from "@fortawesome/free-regular-svg-icons";
import AudioPlayer from "../AudioPlayer";
import { messagesList } from "../../Constants";

const reactions = ["👍", "❤️", "🤩", "😵", "😡"];

const ChatModal = ({ show, closeModal }) => {
  const [isTyping, setIsTyping] = useState(false);
  const [data, setData] = useState({
    message: "",
  });

  const onChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const renderMessage = (item, index) => {
    const itemClass = item.isSupport
      ? "message-item support-message"
      : "message-item";

    return (
      <div className={itemClass}>
        <div className="user-img">
          <img src={defaultUserImg} alt="" />
        </div>

        <div className="message-content">
          <div className="message-heading">
            <b>CS,</b> Today 2:20pm
          </div>
          <div className="message-text">
            {item.type === "text" && <p>{item.message}</p>}

            {item.type === "audio" && <AudioPlayer file={item.file} />}

            <div className="reaction-area">
              <span>
                <FontAwesomeIcon icon={faFaceSmile} />
              </span>
              <ul>
                {reactions.map((item, index) => (
                  <li key={`reaction-key-${index}`}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Modal show={show} onHide={closeModal}>
      <Modal.Header>
        <Modal.Title>
          <div className="chat-header">
            <img src={defaultUserImg} alt="" />

            <div className="chat-header-title">
              <h3>Chat Support</h3>
              <p>I’m here to help you.</p>
            </div>
            <div className="close-btn" onClick={closeModal}>
              <FontAwesomeIcon icon={faTimes} size={55} color="#fff" />
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="message-list-wrapper">
          {messagesList.map(renderMessage)}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="chat-form-wrapper">
          <input
            name="message"
            type="text"
            placeholder="Write your message"
            onChange={(e) => onChange(e)}
          />
          <div className="action-btns">
            <span className="record-message">
              <FontAwesomeIcon icon={faMicrophone} color="#4A4C56" />
            </span>
            <span className="send-message">
              <FontAwesomeIcon icon={faPaperPlane} color="#4A4C56" />
            </span>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ChatModal;
